import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelEntity
